<template>
    <form class="card">
        <h3>Цены</h3>
        <Price :data.sync="data.booking.prices"></Price>
    </form>
</template>

<script>
    import Price from '@/components/forms/Price.vue'

    export default {
        props: ['data'],
        components: {
            Price
        }
    }
</script>